import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MSGraphService } from '../../services/msgraph.service';

@Pipe({
  name: 'userDisplayName',
  standalone: true
})
export class UserDisplayNamePipe implements PipeTransform {
  private nameCache = new Map<string, string>();

  constructor(private graphService: MSGraphService) {}

  transform(email: string): Observable<string> {
    if (this.nameCache.has(email)) {
      return of(this.nameCache.get(email)!);
    }

    return this.graphService.getUserProfile$(email).pipe(
      tap((profile) => {
        if (profile?.displayName) {
          this.nameCache.set(email, profile.displayName);
        }
      }),
      map((profile) => profile?.displayName ?? email),
      catchError(() => of(email))
    );
  }
}
